import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface } from "class-validator";
import { Member as WpUser } from "../waypoint/User";
import { Contact } from "./Contact";
import type { Policy } from "./Policy";
import { User } from "./User";

@ValidatorConstraint({
    name: "AutoPayPaymentMethodRequiredValidator",
    async: false,
})
export class AutoPayPaymentMethodRequiredValidator implements ValidatorConstraintInterface {
    validate(value: PolicyBillingSettings[], args: ValidationArguments): boolean {
        const policy = args.object as Policy;
        const { billingSettings } = policy;

        if (billingSettings?.autoPayEnabled && !billingSettings?.paymentMethodId) {
            return false;
        }

        return true;
    }

    defaultMessage(_args: ValidationArguments): string {
        return "Payment method required for automated billing functionality.";
    }
}

@ValidatorConstraint({
    name: "AutoPayContactRequiredValidator",
    async: false,
})
export class AutoPayContactRequiredValidator implements ValidatorConstraintInterface {
    validate(value: PolicyBillingSettings[], args: ValidationArguments): boolean {
        const policy = args.object as Policy;
        const { billingSettings } = policy;

        if (billingSettings?.autoPayEnabled && !PolicyBillingSettings.getContactIds(billingSettings).length) {
            return false;
        }

        return true;
    }

    defaultMessage(_args: ValidationArguments): string {
        return "Contact required for automated billing functionality.";
    }
}

export class PolicyBillingSettings {
    id: number;
    policyId: string;
    autoPayEnabled: boolean;
    paymentMethodId?: string | null;
    /** First selected contact, retained for existing integrations and payment receipts. */
    contactId?: number | null;
    contactIds?: number[] | null;
    contact?: Contact | null;
    paymentDueAtBind?: number;
    upcomingPaymentActionEnabled: boolean;
    paymentDueActionEnabled: boolean;
    preCancellationActionEnabled: boolean;
    specialPaymentTerms?: string | null;
    updatedByGuid?: string;
    updatedBy?: User;
    updatedByWaypointUserId?: string;
    updatedByWaypointUser?: Pick<WpUser, "id" | "displayName">;
}

export namespace PolicyBillingSettings {
    export function getContactEmails(
        settings: Pick<PolicyBillingSettings, "contactId" | "contactIds"> | null | undefined,
        contacts: Pick<Contact, "id" | "email">[]
    ): string[] {
        const ids = getContactIds(settings);
        return [
            ...new Set(
                contacts
                    .filter((contact) => ids.includes(contact.id))
                    .map((contact) => contact.email?.trim().toLowerCase())
                    .filter(Boolean)
            ),
        ];
    }

    export function getContactIds(settings?: Pick<PolicyBillingSettings, "contactId" | "contactIds"> | null): number[] {
        return [...new Set(settings?.contactIds ?? (settings?.contactId ? [settings.contactId] : []))];
    }
}
